/**
 * Role context + hook, split from the <RoleProvider> component (lib/role.tsx)
 * the same way authContext.ts is split from auth.tsx — non-component module
 * so React Fast Refresh keeps working.
 */

import { createContext, useContext } from "react";
import type { AppRole } from "@canvas-sync/shared";

export interface RoleContextValue {
  /** Resolved app role. RoleProvider gates rendering until it's known, so
   *  consumers under the provider always see a real value. */
  role: AppRole;
  /** Convenience flag: write/admin actions render only when true. */
  isAdmin: boolean;
}

export const RoleContext = createContext<RoleContextValue>({
  // Default (no provider) fails closed: no admin affordances.
  role: "none",
  isAdmin: false,
});

export function useRole(): RoleContextValue {
  return useContext(RoleContext);
}
